import $api from "./http";

const GET = "GET";
const POST = "POST";
const PUT = "PUT";
const DELETE = "DELETE";
const PATCH = "PATCH";

export const METHODS = {
  GET,
  POST,
  PATCH,
  PUT,
  DELETE,
};

class BaseService {
  async _doRequest(method, url, data = {}) {
    try {
      const response = await this._getResponse(method, url, data);
      if (!response?.status && response?.status !== 200 && response?.status !== 201) {
        this._handleError(response?.data?.message);
      }

      return response.data;
    } catch (error) {
      if (error?.response?.status !== 403) {
        const errorMessage =
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          error?.message ||
          "An unexpected error occurred.";

        this._handleError(errorMessage);
        throw error;
      }
    }
  }

  async _getResponse(method, url, data) {
    switch (method) {
      case METHODS.GET:
        return $api.get(url, { params: data });
      case METHODS.POST:
        return $api.post(url, data);
      case METHODS.PATCH:
        return $api.patch(url, data);
      case METHODS.DELETE:
        return $api.delete(url, { data });
      case METHODS.PUT:
        return $api.put(url, data);
    }
  }

  _handleError(message) {
    throw new Error(message);
  }
}

export default BaseService;
